module.exports = __webpack_public_path__ + "img/atom-simple.99904ac0.svg";